import script from "./AccordionTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionTransition.vue?vue&type=script&setup=true&lang=js"

import "./AccordionTransition.vue?vue&type=style&index=0&id=b425b43e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b425b43e"]])

export default __exports__